(function ($) {
	// Accordion
	var question = $('.mod-accordion__question'),
		questionContent = $('.mod-accordion__content'),
		activeClass = 'active',
		openClass = 'open',
		answer = '.mod-row';

	$('.mod-accordion__question + .mod-row').hide();

	question.on('click', function () {
		// Get position of clicked link
		var aTag = $(this);

		// Scroll to position of clicked link
		setTimeout(function () {
			$('html,body').animate(
				{
					scrollTop: aTag.offset().top - 81,
				},
				300
			);
		}, 20);

		if ($(this).hasClass(activeClass)) {
			$(this).removeClass(activeClass);
			$(this).parent().find(answer).hide();
			$(this).parent().removeClass(openClass);
		} else {
			$(this).parent().addClass(openClass);
			$(this).addClass(activeClass);
			$(this).parent().find(answer).slideDown(400);
		}

		return false;
	});

	/* Accordion - Show more */
	var accShowMore = $('.mod-accordion--show-more');

	accShowMore.find($('.mod-accordion__item')).hide();

	/* Look through each accordion with --show-more class */
	accShowMore.each(function () {
		var accWrapper = $(this),
			accItems = accWrapper.find('> div').length,
			btnShowMore = $(this).find('.mod-accordion__show-more'),
			loadedItems = $(this).attr('data-items-loaded'),
			loadedItemsValue = parseInt(loadedItems),
			linkURL = $(this).attr('data-link-destination'),
			linkCopy = $(this).attr('data-link-copy'),
			destinationLink = $(this).find('.destination-link');

		/* show the "show more" button if more than 4 items */
		if (accItems > loadedItems) {
			accWrapper.find(btnShowMore).show();
			destinationLink.hide();
		}

		/* show first 4 items of the accordion */
		accWrapper.find('> div:lt(' + loadedItems + ')').show();

		btnShowMore.click(function () {
			loadedItemsValue = loadedItemsValue + 2;

			/* load the next 2 items */
			$(this)
				.parent()
				.find(' > div:lt(' + loadedItemsValue + ')')
				.show();

			/* 	if all items are loaded add 'loaded' text and add
				'loaded' class */
			if (loadedItemsValue >= accItems) {
				$(this).hide();
				destinationLink.show().attr('href', linkURL).html(linkCopy);
				return false;
			}
			return false;
		});
	});
})(window.jQuery);
